export default __webpack_public_path__ + "static/online-b2cda4795a86b23efd8961c4ce294a32.jpg";